export const preRegisterValues = {
  cpf: '',
  fullName: '',
  phone: '',
  email: '',
  confirmEmail: '',
  birthDate: '',
}
